function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-886 -259)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(778 153)"
}, React.createElement("path", {
  d: "m131.957 111 7.293 7.293V141h-23.5v-30h16.207zm-.707 1h-14.5v28h21.5v-21h-7v-7zm-6.93 13.07c.92 0 1.45.46 1.63.69.08.11.11.19.11.31 0 .27-.21.48-.48.48-.16 0-.28-.07-.37-.17a1.14 1.14 0 0 0-.89-.39c-.7 0-1.08.54-1.08 1.48 0 .96.38 1.49 1.08 1.49.46 0 .76-.23.99-.4.11-.08.2-.1.3-.1.27 0 .48.21.48.48 0 .14-.05.26-.17.37-.23.21-.78.57-1.6.57-1.36 0-2.17-.78-2.17-2.41 0-1.63.81-2.4 2.17-2.4zm4.16 0c.71 0 1.34.27 1.62.62.06.08.1.15.1.3 0 .26-.22.48-.48.48-.14 0-.23-.06-.34-.14-.22-.16-.49-.32-.9-.32-.37 0-.59.13-.59.38 0 .74 2.46.4 2.46 2.05 0 .94-.8 1.42-1.83 1.42-.86 0-1.52-.39-1.77-.7a.465.465 0 0 1-.12-.31c0-.26.22-.48.48-.48.1 0 .2.03.31.12.27.22.6.41 1.1.41.45 0 .74-.12.74-.4 0-.81-2.45-.39-2.45-2.09 0-.9.75-1.34 1.67-1.34zm-7.74 3.44c.42 0 .65.22.65.67 0 .44-.23.65-.65.65-.42 0-.66-.21-.66-.65 0-.45.24-.67.66-.67zm13.74-3.38c.3 0 .54.24.54.54 0 .09-.02.16-.04.21l-1.6 3.62c-.09.2-.27.33-.5.33-.23 0-.41-.13-.5-.33l-1.6-3.62a.558.558 0 0 1-.04-.21c0-.3.24-.54.54-.54.3 0 .45.21.5.34l1.1 2.78 1.1-2.78c.05-.13.2-.34.5-.34zm-2.23-12.423V118h5.293l-5.293-5.293z",
  fill: "currentColor",
  fillRule: "nonzero"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/csv.fccb81c1.svg";
export { SvgComponent as ReactComponent };